// Teacher Dashboard Action Creators
import * as UserActionCreators from "../reducers/user/actions";
import * as SignUpActionCreators from "../reducers/sign_up/actions";
import * as ClassesActionCreators from "../reducers/classes/actions";
import * as StudentsActionCreators from "../reducers/students/actions";
import * as StudentActionCreators from "../reducers/student/actions";
import * as GradingScalesActionCreators from "../reducers/grading_scales/actions";
import * as AnswerSheetsActionCreators from "../reducers/answer_sheets/actions";
import * as AssessmentsActionCreators from "../reducers/assessments/actions";
import * as GradingsActionCreators from "../reducers/grading/actions";

const actions = {
    ...UserActionCreators,
    ...SignUpActionCreators,
    ...ClassesActionCreators,
    ...StudentsActionCreators,
    ...StudentActionCreators,
    ...GradingScalesActionCreators,
    ...AnswerSheetsActionCreators,
    ...AssessmentsActionCreators,
    ...GradingsActionCreators,
}

export default actions;
